





























































// import { Component, Mixins } from 'vue-mixin-decorator';
import { Component, Vue } from 'vue-property-decorator';
import WorkHttp from '@/http/WorkHttp';
import { namespace } from 'vuex-class';
import { NAMESPACE as P_NAMESPACE } from '@/store/models/work/enterprise/positions';
import { NAMESPACE as C_NAMESPACE } from '@/store/models/work/enterprise/customers';
import { GET_ITEM, GET_ITEMS, LOADING, SHOW_REQUEST } from '@/store';
import CustomerItem from '@/components/work/customers/Item.vue';
import Map from '@/components/gMap/Map.vue';
import { CustomerModel, Provider } from '@/store/types/work/Providers';
const positionsStore = namespace(P_NAMESPACE);
const customerStore = namespace(C_NAMESPACE);
@Component({
  components: { Map, CustomerItem }
})
export default class CustomersMapComponent extends Vue {
  loadingCustomers = false;
  public customers:Provider[] = [];
  public withoutLocations:Provider[] = [];
  @positionsStore.Getter(GET_ITEMS) positions!:any[];

  @customerStore.Action(SHOW_REQUEST) showCustomerRequest!: any
  @customerStore.Getter(GET_ITEM) customer!: any
  @customerStore.Getter(LOADING) loading!: boolean

  public filters = {
    manager_id: null
  };

  public getItem (item:Provider) {
    this.showCustomerRequest(item.id);
  }

  public getCustomers () {
    this.loadingCustomers = true;
    (new WorkHttp(435)).request({
      url: '/customers',
      params: {
        filters: { ...this.filters }
      }
    }).then(res => {
      this.customers = [];
      this.withoutLocations = [];
      if (res.data.data) {
        res.data.data.forEach((item:Provider) => {
          if (item.data.enterprise && item.data.enterprise.location) {
            this.customers.push(item);
          } else {
            this.withoutLocations.push(item);
          }
        });
      }
    }).then(() => {
      this.loadingCustomers = false;
    });
  }

  created () {
    this.getCustomers();
  }
}
